import { liveScoringRoundStarted } from '@moment-golf/shared';

/** True if any loaded event score row has a started current round (scores entered or confirmed). */
export function currentRoundScoringStarted(
    scoreData: any[],
    currentRound: number,
    eventData: any,
): boolean {
    if (!Array.isArray(scoreData) || scoreData.length === 0) return false;
    const scoreType = eventData?.scoreType;
    return scoreData.some((score: any) => {
        const rs = score.roundScores?.[currentRound - 1];
        return liveScoringRoundStarted(rs, scoreType);
    });
}
